class Download {
  constructor(config = {}) {
    this.data = config.data || [];
    this.csvData = [];
    this.visible = config.visible || false;
  }

  /**
   * Method that controls what content is visible
   * in the download sidebar
   * @param {boolean} state true/false
   */
  toggleVisibility(state) {
    this.visible = state;
    this.updateContent();
    return this;
  }

  /**
   * Method used to update the data property on the instance
   * Also prepares the data for CSV export by converting
   * the data from an array of an objects to an array
   * of arrays of values
   * @param {array} data
   */
  setData(data) {
    this.data = data;
    if (this.data.length > 0) {
      const keys = Object.keys(this.data[0]);
      const newData = this.data.map((d) => {
        return Object.values(d);
      });
      newData.unshift(keys);
      this.csvData = newData;
    } else {
      this.csvData = [];
    }
    return this;
  }

  /**
   * Method used to kick of the process of generating
   * and saving the CSV
   */
  downloadCSV() {
    if (this.csvData.length > 0) {
      const csvContent = "data:text/csv;charset=utf-8,"
        + this.csvData.map(e => e.join(",")).join("\n");
      const encodedUri = encodeURI(csvContent);
      const $link = document.querySelector('.download-btn');
      $link.setAttribute("href", encodedUri);
      $link.setAttribute("download", "colors_of_water_download.csv");
    }
  }

  /**
   * Method used to determine what content is shown in the
   * download sidebar.
   * Shows a download button if the time series viewer is selected
   * and shows text if the upstream to downstream viewer is selected
   */
  updateContent() {
    const $content = document.querySelector('.meta-data-display-container .download-content');
    if (!this.visible) {
      $content.innerHTML = `
        <p class="download-instructions layout-padding">
          Switch to the time series view to download data.
        </p>
      `;
    } else {
      $content.innerHTML = `
        <p class="download-instructions layout-padding">
          <a href="#" target="_blank" rel="noreferrer" class="btn download-btn">
            Download Data
          </a>
        </p>
      `;
      const $link = document.querySelector('.download-btn');
      $link.addEventListener('click', this.downloadCSV.bind(this));
    }
    return this;
  }

}